import React, { useEffect } from 'react'
import { Outlet } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

import Header from "./Header";
import Sidebar, { SIDEBAR_W } from "./Sidebar";

import { GET, httpOk } from 'helpers/api'
import { SET_ACCOUNT } from 'store/account/action'

/**
 * Ishlab chiqarish bo'limi layouti.
 *
 * 2026-08-01 dan: chapda doimiy YON MENYU (egasi/adminникi kabi), tepada esa
 * faqat til va profil. Ilgari hamma o'tish tugmasi tepada bir qatorda turardi
 * va faol sahifa ajralmasdi.
 *
 * ⚠️ `sidebar-active-margin` / `vertical-menu` klasslari ISHLATILMAYDI —
 * verical.css:288 da `.vertical-menu { width: 50px !important }` bor va u
 * egasining piktogramma ustuni uchun mo'ljallangan. Bu yerda menyu doim to'liq
 * ochiq, shuning uchun kenglik bitta joydan (SIDEBAR_W) beriladi.
 */
function Layout() {
	const dispatch = useDispatch()
	const account = useSelector(state => state.account)

	/* BO'LIMLARNI YANGILASH.
	 *
	 * Muammo: usta qaysi bo'limga biriktirilgani (`product_types`) FAQAT kirish
	 * paytida localStorage ga yozilardi. Rahbar xodimga bo'lim biriktirsa, usta
	 * tizimdan chiqib qayta kirmaguncha eski ro'yxat bilan ishlardi — Kengash
	 * ham, Cheklar ham, Kunlik ish ham BO'SH ko'rinardi va sababi bilinmasdi.
	 *
	 * Endi har ochilganda bazadagi haqiqiy ro'yxat so'raladi. O'zgargan bo'lsa
	 * saqlanadi va sahifa bir marta qayta yuklanadi: Kengash `product_types` ni
	 * faqat birinchi chizilishda o'qiydi, shusiz yangi bo'lim ochilmasdi.
	 */
	useEffect(() => {
		let alive = true

		async function syncDepartments() {
			const res = await GET('/helper/my-product-types', {}, { loader: false })
			if (!alive || !httpOk(res) || !Array.isArray(res.data)) return

			const fresh = JSON.stringify(res.data)
			const stored = localStorage.getItem('product_types')
			if (stored === fresh) return

			localStorage.setItem('product_types', fresh)
			dispatch(SET_ACCOUNT({ ...account, product_types: res.data }))
			window.location.reload()
		}

		syncDepartments()
		return () => { alive = false }
	}, []) // eslint-disable-line react-hooks/exhaustive-deps

	return (
		<div id="layout-wrapper">
			<Header />
			<Sidebar />
			<div style={{ marginLeft: SIDEBAR_W }}>
				<div className="page-content">
					<Outlet />
				</div>
			</div>
		</div>
	)
}

export default Layout
